import ApiService from "@/common/api/api.service";

const Detalhes = {

    buscar: function(rubrica, id,realizado, endpoint, nomeId) {
        return ApiService.get(`${endpoint}/${rubrica}-${realizado ? 'realizado' : 'previsto'}?${nomeId}=${id}`);
    },

    salvar: function(rubrica, form, realizado, endpoint) {
        if(!form.id)
            return ApiService.post(`${endpoint}/${rubrica}-${realizado ? 'realizado' : 'previsto'}`, form);
        
        return ApiService.put(`ProjetoGestao/${rubrica}-${realizado ? 'realizado' : 'previsto'}`, form);
    },

    excluir: function(rubrica, id, realizado) {
        return ApiService.delete(`ProjetoGestao/${rubrica}-${realizado ? 'realizado' : 'previsto'}`, { id : id });
    },
    
    downloadArquivo: function(rubrica, id, arquivoTipo) {
        return ApiService.downloadFile(`ProjetoGestao/${rubrica}-realizado/download-arquivo?custoId=${id}&arquivoTipo=${arquivoTipo}`)
    },

};

export default Detalhes;